<div class="flex-privacy-container">
	<router-outlet />
	<ngx-global-contact-footer [disableFeedback]="true"></ngx-global-contact-footer>
</div>